const Config = {
  train: {
    url: '/train'
  }
}

export default Config;



// WEBPACK FOOTER //
// ./src/js/config/config.js